import * as z from 'zod'

import { useCommonSchema } from './commonSchema'

export const useEmailSchema = () => {
  const { email } = useCommonSchema()

  const emailSchema = z.object({
    email,
  })

  return emailSchema
}

export type IEmailSchema = z.infer<ReturnType<typeof useEmailSchema>>
